var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMspIconKsxSyncInvExAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 20L6 20L6 4L9 4L9 20Z",
    fill: "#006DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20L15 20L15 4L18 4L18 20Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMspIconKsxSyncInvExAgent);
export default __webpack_public_path__ + "static/media/msp-icon-ksx-sync_inv_ex_agent.50ce6e9b1573b53b526124352a7fda31.svg";
export { ForwardRef as ReactComponent };